export default __webpack_public_path__ + "static/media/user.50bcbd59.svg";